import { render } from "./UcariPromo.vue?vue&type=template&id=ca1c77a6&scoped=true"
const script = {}

import "./UcariPromo.vue?vue&type=style&index=0&id=ca1c77a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1c77a6"]])

export default __exports__